import { render } from "./my-environment-menu.vue?vue&type=template&id=eedf2ac2&scoped=true&ts=true&lang=pug"
import script from "./my-environment-menu.vue?vue&type=script&lang=ts"
export * from "./my-environment-menu.vue?vue&type=script&lang=ts"

import "./my-environment-menu.vue?vue&type=style&index=0&id=eedf2ac2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eedf2ac2"]])

export default __exports__